import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import {
  AntiMoneyLaunderingParameters,
  Owner,
  PledgeOwnerRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  get pledgeOwners() {
    return this.form.get('pledgeOwners') as UntypedFormArray;
  }
  generate(entity: Owner[], accountId: number) {
    let pledgeOwners: UntypedFormGroup[] = [];
    const owners = entity;
    if (!!owners && owners?.length) {
      for (let owner of owners) {
        const antiMoneyLaunderingFormGroup = this.formBuilder.group({
          id: [owner?.antiMoneyLaundering?.id || null],
          ownerId: [owner?.antiMoneyLaundering?.ownerId || null],
          accountId: [owner?.antiMoneyLaundering?.accountId || accountId],
          beneficialOwnerId: [
            owner?.antiMoneyLaundering?.beneficialOwnerId || null,
          ],
          profile: ['PHYSICAL'],
          ppe: [
            _.isNil(owner?.antiMoneyLaundering?.ppe)
              ? false
              : owner?.antiMoneyLaundering?.ppe,
            Validators.required,
          ],
          adresseDomiciliation: [
            _.isNil(owner?.antiMoneyLaundering?.adresseDomiciliation)
              ? false
              : owner?.antiMoneyLaundering?.adresseDomiciliation,
            Validators.required,
          ],
          fortuneInfluent: [
            _.isNil(owner?.antiMoneyLaundering?.fortuneInfluent)
              ? false
              : owner?.antiMoneyLaundering?.fortuneInfluent,
            Validators.required,
          ],
          secteurRisqueCorruption: [
            _.isNil(owner?.antiMoneyLaundering?.secteurRisqueCorruption)
              ? false
              : owner?.antiMoneyLaundering?.secteurRisqueCorruption,
            Validators.required,
          ],
          discretionInhabituelle: [
            _.isNil(owner?.antiMoneyLaundering?.discretionInhabituelle)
              ? false
              : owner?.antiMoneyLaundering?.discretionInhabituelle,
            Validators.required,
          ],
          personneListeGelsDesAvoirs: [
            _.isNil(owner?.antiMoneyLaundering?.personneListeGelsDesAvoirs)
              ? false
              : owner?.antiMoneyLaundering?.personneListeGelsDesAvoirs,
            Validators.required,
          ],
          fondListeGelsDesAvoirs: [
            _.isNil(owner?.antiMoneyLaundering?.fondListeGelsDesAvoirs)
              ? false
              : owner?.antiMoneyLaundering?.fondListeGelsDesAvoirs,
            Validators.required,
          ],
          versementPeePerco: [
            _.isNil(owner?.antiMoneyLaundering?.versementPeePerco)
              ? false
              : owner?.antiMoneyLaundering?.versementPeePerco,
            Validators.required,
          ],
          produitsAtypiques: [
            _.isNil(owner?.antiMoneyLaundering?.produitsAtypiques)
              ? false
              : owner?.antiMoneyLaundering?.produitsAtypiques,
            Validators.required,
          ],
          controleActifsFonds: [
            _.isNil(owner?.antiMoneyLaundering?.controleActifsFonds)
              ? false
              : owner?.antiMoneyLaundering?.controleActifsFonds,
            Validators.required,
          ],
          compteTitreAugmentationCapital: [
            _.isNil(owner?.antiMoneyLaundering?.compteTitreAugmentationCapital)
              ? false
              : owner?.antiMoneyLaundering?.compteTitreAugmentationCapital,
            Validators.required,
          ],
          primeAnnuelleUnique: [
            _.isNil(owner?.antiMoneyLaundering?.primeAnnuelleUnique)
              ? false
              : owner?.antiMoneyLaundering?.primeAnnuelleUnique,
            Validators.required,
          ],
          contratPrevoyanceSante: [
            _.isNil(owner?.antiMoneyLaundering?.contratPrevoyanceSante)
              ? false
              : owner?.antiMoneyLaundering?.contratPrevoyanceSante,
            Validators.required,
          ],
          assuranceEmprunteur: [
            _.isNil(owner?.antiMoneyLaundering?.assuranceEmprunteur)
              ? false
              : owner?.antiMoneyLaundering?.assuranceEmprunteur,
            Validators.required,
          ],
          contratAssuranceSansClauseRachat: [
            _.isNil(
              owner?.antiMoneyLaundering?.contratAssuranceSansClauseRachat,
            )
              ? false
              : owner?.antiMoneyLaundering?.contratAssuranceSansClauseRachat,
            Validators.required,
          ],
          contratAnonyme: [
            _.isNil(owner?.antiMoneyLaundering?.contratAnonyme)
              ? false
              : owner?.antiMoneyLaundering?.contratAnonyme,
            Validators.required,
          ],
          produitsImmobiliersLuxe: [
            _.isNil(owner?.antiMoneyLaundering?.produitsImmobiliersLuxe)
              ? false
              : owner?.antiMoneyLaundering?.produitsImmobiliersLuxe,
            Validators.required,
          ],
          operationPaysGafi: [
            _.isNil(owner?.antiMoneyLaundering?.operationPaysGafi)
              ? false
              : owner?.antiMoneyLaundering?.operationPaysGafi,
            Validators.required,
          ],
          fondPaysGafi: [
            _.isNil(owner?.antiMoneyLaundering?.fondPaysGafi)
              ? false
              : owner?.antiMoneyLaundering?.fondPaysGafi,
            Validators.required,
          ],
          operationPaysNonCooperatif: [
            _.isNil(owner?.antiMoneyLaundering?.operationPaysNonCooperatif)
              ? false
              : owner?.antiMoneyLaundering?.operationPaysNonCooperatif,
            Validators.required,
          ],
          fondPaysNonCooperatif: [
            _.isNil(owner?.antiMoneyLaundering?.fondPaysNonCooperatif)
              ? false
              : owner?.antiMoneyLaundering?.fondPaysNonCooperatif,
            Validators.required,
          ],
        });

        const formConfig: FormConfig<
          PledgeOwnerRead & {
            antiMoneyLaundering: AntiMoneyLaunderingParameters;
          }
        > = {
          id: [owner.id],
          ownerId: [owner.ownerId],
          userId: [owner.userId],
          userFirstName: [owner.userFirstName],
          userLastName: [owner.userLastName],
          company: [owner.company || null],
          antiMoneyLaundering: antiMoneyLaunderingFormGroup,
        };

        const formBuilderGroup = this.formBuilder.group(formConfig, {});
        pledgeOwners.push(formBuilderGroup);
      }
    }

    let group = this.formBuilder.group({
      pledgeOwners: this.formBuilder.array(
        pledgeOwners,
        Validators.nullValidator,
      ),
    });

    this.form = group;

    return group;
  }

  extract() {
    const formValue = _.cloneDeep(this.form.value.pledgeOwners);

    return { owners: formValue };
  }
}
